export enum CalendarType {
  STACKED_CALENDAR = 'STACKED_CALENDAR',
  STANDALONE_CALENDAR = 'STANDALONE_CALENDAR',
}
